import React, { useState, useEffect, useMemo } from "react";
import "intersection-observer";
import { ErrorPlaceholder } from "../../../components/placeholder";
import request from "../../../network/request";
import styles from "./index.module.scss";
import { ISubOrderList } from "../types";
import useGetCh from "../../../hooks/useGetCh";
import { reportUserBehavior } from "../../../utils/common";
import useQuery from "../../../hooks/useQuery";
import ProgressItem from "./components/progressItem";
import LoadingHomepage from "../../maintence/components/LoadingHomepage";
import moment from "moment";
import { refreshPageByBack } from "../utils";
import phoneIcon from "./phone.svg";
import {
  SERVICE_GRAY_STATUS,
  SERVICE_GREEN_STATUS,
  SERVICE_ORANGE_STATUS,
} from "../constant";
import ReportEntry from "./components/reportEntry";

const initialOrderList = {
  mainOrderInfo: {
    // uuid: "", //主单uuid
    // mainOrderType: 0, //服务主单类型编码：100=移动；200=维保；300=结算
    // mainOrderTypeText: "", //服务主单类型名称
    // mainOrderStatus: 0, //服务主单状态编码： 1000=预约； 2000=环检； 3000=施工； 4000=结算； 5000=还车
    // mainOrderStatusText: "", //服务主单状态名称
    // serviceTimeTitle: "", //服务时间名称：预约时间，开始时间
    // serviceTime: "", //服务时间
    // serviceAddressTitle: "", //服务地点名称：服务网点，服务地点
    // serviceAddress: "", //服务地点value
    // vin: "", //车架号
    // vehicleSeries: "", //车系
    // plateNumber: "", //车牌
    // uid: 0 //用户uid
  },
  subOrderList: [
    // {
    //   ssReserveOrderCode: 0, //移动远程单号:subOderType=101,subOderType=102时有效
    //   reserveId: 0, //预约单id：subOderType=201时有效
    //   aroundCheckOrderNo: "", //环检单号：subOderType=202时有效
    //   repairOrderCode: "", //施工单号：subOderType=203时有效
    //   drivingOrderRecordSubId: 0, //还车单号：subOderType=204时有效
    //   repairSettlementOrderId: 0, //施工结算单id: subOderType=301时有效
    //   salesSettlementOrderId: 0, //外销结算单id: subOderType=302时有效
    //   subOrderType: 0, //子单类型编码：移动单=101；远程单=102；预约单=201；环检单=202；施工单=203；还车单=204；施工结算单=301；外销结算单=302
    //   subOrderTypeText: "", //子单类型名称
    //   subOrderStatus: 0, //子单状态编码
    //   subOrderStatusText: "", //子单状态名称
    //   serviceTimeTitle: "", //服务时间名称：预约时间，开始时间
    //   serviceTime: "", //服务时间
    //   serviceAddressTitle: "", //服务地点名称：服务网点，服务地
    //   serviceAddress: "", //服务地点
    //   vin: "", //车架号
    //   vehicleSeries: "", //车系
    //   plateNumber: "", //plateNumber
    //   settlementAmount: 0, //结算金额（subOrderType=301或302时有效）
    //   serviceEngineerName: "", //服务工程师姓名(subOrderType=203时有效)
    //   verifyCode: "", //还车验证码(subOrderType=204时有效)
    //   displayDetail: 1, //是否展示详情（0/1）,默认展示
    //   actions: [
    //     {
    //       desc: "", //动作描述
    //       text: "", //按钮文案
    //       url: "" //跳转链接
    //     }
    //   ]
    // }
  ],
};

export default function () {
  document.title = "服务记录";
  const query = useQuery();
  const serviceOrderUuid = query.get("serviceOrderUuid");
  const ch = useGetCh();
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingError, setIsLoadingError] = useState(false);
  const [orderList, setOrderList] = useState<ISubOrderList>(initialOrderList);
  const [errorMsg, setErrorMsg] = useState("");

  const statusClassName = useMemo(() => {
    const greenList: any[] = SERVICE_GREEN_STATUS;
    const orangeList: any[] = SERVICE_ORANGE_STATUS;
    const grayList: any[] = SERVICE_GRAY_STATUS;
    const status = orderList?.mainOrderInfo?.mainOrderStatus;

    if (greenList.includes(status)) {
      return styles.greenOrderStatus;
    } else if (orangeList.includes(status)) {
      return styles.orangeOrderStatus;
    } else if (grayList.includes(status)) {
      return styles.grayOrderStatus;
    } else {
      return styles.baseOrderStatus;
    }
  }, [orderList]);

  useEffect(() => {
    getInitOrderList();
    refreshPageByBack();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (!isLoading && !isLoadingError) {
      reportUserBehavior(
        {
          so: "J001002",
          mcode: "sub_order_list",
          ch,
          pa: `status=success`,
        },
        "page"
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isLoadingError]);

  const getInitOrderList = async () => {
    setIsLoading(true);
    setIsLoadingError(false);
    await requestSubOrderList();
    setIsLoading(false);
  };

  const requestSubOrderList = async () => {
    console.log(serviceOrderUuid);
    try {
      const data: any = await request(
        "serviceOrder/getJourneyDetail",
        {
          orderCode: serviceOrderUuid,
        },
        "POST"
      );
      reportUserBehavior({
        so: "J001002",
        mcode: "main_order_list__req_get_sub_order_list_success",
        ch,
        pa: `status=success\`serviceOrderUuid=${serviceOrderUuid}`,
      });

      console.log(data, "子单数据");
      setOrderList(data);
    } catch (err) {
      reportUserBehavior({
        so: "J001002",
        mcode: "main_order_list__req_get_sub_order_list_error",
        ch,
        pa: `status=error\`serviceOrderUuid=${serviceOrderUuid}`,
      });
      setIsLoading(false);
      setIsLoadingError(true);
      setErrorMsg((err as any).message || "获取服务订单失败，请稍后重试");
    }
  };

  if (isLoading) {
    return <LoadingHomepage></LoadingHomepage>;
  }

  if (isLoadingError) {
    reportUserBehavior(
      {
        so: "J001002",
        mcode: "sub_order_list",
        ch,
        pa: `status=error`,
      },
      "page"
    );
    return (
      <ErrorPlaceholder
        message={errorMsg}
        getData={getInitOrderList}
      ></ErrorPlaceholder>
    );
  }

  const progressInfo = orderList?.subOrderList?.map((item, index) => {
    // 子单类型编码：移动单=101；远程单=102；预约单=201；环检单=202；
    // 施工单=203；还车单=204；施工结算单=301；外销结算单=302； 取车服务=103
    if (
      item.subOrderType === 101 ||
      item.subOrderType === 102 ||
      item.subOrderType === 103 ||
      item.subOrderType === 201 ||
      item.subOrderType === 202 ||
      item.subOrderType === 203 ||
      item.subOrderType === 204 ||
      item.subOrderType === 301 ||
      item.subOrderType === 302
    ) {
      return (
        <ProgressItem
          content={item}
          firstItem={index === 0}
          key={index}
          lastItem={index === orderList?.subOrderList.length - 1}
        />
      );
    } else {
      return null;
    }
  });

  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        <div className={styles.cellWapper}>
          <div className={styles.cellTitle}>
            <h3>维保服务</h3>
          </div>
          <div className={statusClassName}>
            {orderList?.mainOrderInfo?.mainOrderStatusText}
          </div>
        </div>
        <div className={styles.cellWapper}>
          <div className={styles.cellTitle}>服务地点</div>
          <div className={styles.cellContent}>
            {orderList?.mainOrderInfo?.serviceAddress}
          </div>
        </div>
        {orderList?.mainOrderInfo?.serviceTimeTitle &&
          orderList?.mainOrderInfo?.serviceTime && (
            <div className={styles.cellWapper}>
              <div className={styles.cellTitle}>
                {orderList?.mainOrderInfo?.serviceTimeTitle}
              </div>
              <div className={styles.cellContent}>
                {orderList?.mainOrderInfo?.serviceTime
                  ? moment(orderList?.mainOrderInfo?.serviceTime as any).format(
                      "YYYY/MM/DD HH:mm"
                    )
                  : "-"}
              </div>
            </div>
          )}
        <div className={styles.cellWapper}>
          <div className={styles.cellTitle}>车辆</div>
          <div className={styles.cellContent}>
            {orderList?.mainOrderInfo?.plateNumber ||
              orderList?.mainOrderInfo?.vin}
          </div>
        </div>
        {orderList?.mainOrderInfo?.saName && (
          <div className={styles.cellWapper}>
            <div className={styles.cellTitle}>服务管家</div>
            <a
              className={styles.cellContent}
              href={`tel:${orderList?.mainOrderInfo?.saTel}`}
            >
              {orderList?.mainOrderInfo?.saName}
              <img src={phoneIcon} alt="" className={styles.phoneIcon} />
            </a>
          </div>
        )}
        {orderList?.subOrderList?.find((item) => !!item.repairOrderCode) && (
          <div className={styles.cellWapper}>
            <div className={styles.cellTitle}>总金额</div>
            <div className={styles.cellContent}>
              ￥{orderList?.mainOrderInfo?.totalAmount}
            </div>
          </div>
        )}
      </div>

      {/* 保养报告 */}
      <ReportEntry url={orderList?.mainOrderInfo.reportUrl} />

      <div className={styles.progressWrapper}>{progressInfo}</div>
    </div>
  );
}
